import { screenSizeCoefficient } from './breakpoints'

export function updateFontSize(defaultFontSize, smallScreenHeightFontSize, maxFontSize) {

  let $html = $('html')
  let screenW = $(window).width()
  let screenH = $(window).height()
  let fontSize = Math.floor(defaultFontSize * screenSizeCoefficient())

  fontSize = fontSize > maxFontSize ? maxFontSize : fontSize

  if (screenW > 1000 && screenH < 720) {
    fontSize = smallScreenHeightFontSize
  }
  $html.css('font-size', fontSize + 'px')

}
